<script>
  import { Link } from "svelte-routing";
  import { onMount } from "svelte";
  import { navigate } from "svelte-routing";
  import emailjs from "@emailjs/browser";
  
  function navigateTo(destination) {
    goto(destination);
  }

  // Contact form state
  let firstName = "";
  let lastName = "";
  let company = "";
  let email = "";
  let phone = "";
  let helpOption = "";
  let message = "";
  let submitting = false;
  let submitStatus = "";

  async function handleSubmit() {
    submitting = true;
    submitStatus = "";

    const payload = {
      title: "Free Consultation Request",
      to_email: "craft2code743@gmail.com",
      name: firstName + " " + lastName,
      from_name: firstName + " " + lastName,
      email: email,
      from_email: email,
      company: company,
      phone: phone,
      help_option: helpOption,
      message: message,
    };

    try {
      const response = await emailjs.send(
        "service_3137pxo",
        "template_kxc76ui",
        payload
      );
      console.log("✅ Email sent successfully!", response.status, response.text);
      submitStatus = "success";
      firstName = ""; lastName = ""; company = ""; email = "";
      phone = ""; helpOption = ""; message = "";
    } catch (err) {
      console.error("❌ EmailJS failed to send email.", err);
      submitStatus = "error";
    }
    submitting = false;
  }
 
  let prevScrollPos = window.pageYOffset || document.documentElement.scrollTop;
  onMount(() => {
    emailjs.init("fHRZE2qnPN5GaQpnY");
    window.addEventListener("scroll", handleScroll);
  });

  function handleScroll() {
    const currentScrollPos =
      window.pageYOffset || document.documentElement.scrollTop;
    const element = document.getElementById("footerImage");
    const rect = element.getBoundingClientRect();
    const windowHeight =
      window.innerHeight || document.documentElement.clientHeight;

    // Calculate the distance scrolled since the last scroll event
    const scrollDistance = currentScrollPos - prevScrollPos;

    // Calculate the scaling factor based on the scroll direction
    const scaleIncrement = scrollDistance > 0 ? 0.01 : -0.01;

    // Adjust the scale of the image
    const currentScale =
      parseFloat(
        element.style.transform.replace("scale(", "").replace(")", "")
      ) || 1;
    const newScale = Math.max(
      0.6,
      Math.min(0.8, currentScale + scaleIncrement)
    ); // Limit the scale between 0.5 and 1.5

    // Update the scale of the image
    element.style.transform = `scale(${newScale})`;

    // Update previous scroll position
    prevScrollPos = currentScrollPos;
  }

  // Logo scroll effect removed — logo stays centered in its container

  let currentIndex = 0;

  function moveCard(direction) {
    const cards = document.querySelectorAll(".cardb");
    if (direction === "left") {
      if (currentIndex > 0) {
        currentIndex--;
      }
    } else if (direction === "right") {
      if (currentIndex < cards.length - 2) {
        currentIndex++;
      }
    }
  }

  function getRandomPosition() {
    const randomX = Math.random() * 280; // Adjust range as needed
    const randomY = Math.random() * 200; // Adjust range as needed
    return `translate(${randomX}%, ${randomY}%)`;
  }

  const arrow = document.querySelector(".arrow-up");

  // Add scroll event listener
  window.addEventListener("scroll", () => {
    // Check if scroll position is greater than 100px (adjust as needed)
    if (window.scrollY > 200) {
      // If scrolled down, move the arrow down by 20px
      arrow.style.top = "60px";
    } else {
      // If scrolled up, move the arrow back to its original position
      arrow.style.top = "10px";
    }
  });

  let testimonialIndex = 0;
  const testimonials = [
    {
      quote:
        "I've been consistently impressed with the quality of work from Craft2Code. Their expertise in project planning and execution is unparalleled, and they always deliver on time. The team is skilled, dedicated, and professional, ensuring the highest standards in every aspect of their work.",
      author: "Fady Bachir",
    },
    {
      quote:
        "Craft2Code helped us launch our mobile app with a tight deadline and complex requirements. Their team was responsive, detail-oriented, and proactive in solving issues before they became problems. I would definitely work with them again.",
      author: "Sarah Khalil, Product Manager",
    },
    {
      quote:
        "Working with Craft2Code was a seamless experience. They understood our project requirements from the start and delivered a web platform that exceeded our expectations. Communication was clear and consistent throughout the process.",
      author: "Karim Mansour, CTO",
    },
  ];

  function goToPrevTestimonial() {
    testimonialIndex =
      (testimonialIndex - 1 + testimonials.length) % testimonials.length;
  }

  function goToNextTestimonial() {
    testimonialIndex = (testimonialIndex + 1) % testimonials.length;
  }

  let parallaxImage;
  let containerTop = 0;
  let containerHeight = 0;
  let windowHeight = 0;

  onMount(() => {
    const container = document.querySelector(".parallax-container");
    containerTop = container.offsetTop;
    containerHeight = container.offsetHeight;
    windowHeight = window.innerHeight || document.documentElement.clientHeight;

    window.addEventListener("scroll", handleScrollp);

    return () => {
      window.removeEventListener("scroll", handleScrollp);
    };
  });

  function handleScrollp() {
    const scrollPosition =
      window.pageYOffset || document.documentElement.scrollTop;

    // Check if the scroll position is within the range of the container
    if (
      scrollPosition >= containerTop - windowHeight &&
      scrollPosition <= containerTop + containerHeight
    ) {
      // Calculate the translation distance for the parallax effect
      const translation = (scrollPosition - containerTop + windowHeight) * 0.5;
      // Apply the translation to the image
      parallaxImage.style.transform = `translateY(${translation}px)`;
    } else {
      // If the scroll position is outside the container range, reset the translation
      parallaxImage.style.transform = `translateY(0px)`;
    }
  }
  // Get the rightlo div
</script>

<svelte:head>
  <link
    rel="stylesheet"
    href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css"
  />
</svelte:head>

<div class="ho1">
  <div class="left">
    <h2>
      Where Vision Meets Code.<br />
      Where Ideas Are Crafted<br />
      into Reality.
    </h2>
    <p>
      At Craft2Code, we design and develop scalable<br />
      digital solutions that drive measurable results.
    </p>
    <Link to="/contact">
      <button class="card-btnn">Schedule a Free Consultation</button>
    </Link>
    <Link to="/service">
      <button class="services-btnn">Services</button>
    </Link>
  </div>
  <div class="right">
    <div class="image-container">
      <div class="image-background"></div>
      <div class="image-background1"></div>
      <img src="/img/1.jpg" alt="Image" />
    </div>
  </div>
</div>

<div class="ho2">
  <div class="detail-container">
    <div class="detail">
      <p>
        <span style="color: red;">★</span><span style="color: red;">★</span
        ><span style="color: red;">★</span><span style="color: red;">★</span
        ><span style="color: red;">★</span> Rated
      </p>
      <p>
        <span style="color: gray;">31+ Reviews</span>
      </p>
    </div>
    <div class="vertical-line"></div>
    <div class="detail blue-text">
      <p>Experienced Team</p>
      <p>Proven Industry Expertise</p>
    </div>
    <div class="vertical-line"></div>
    <div class="detail blue-text">
      <p>Client-Focused Approach</p>
      <p>Commitment to Satisfaction</p>
    </div>
    <div class="vertical-line"></div>
    <div class="detail blue-text">
      <p>1000+ Solutions Built</p>
      <p>Projects Successfully Delivered</p>
    </div>
    <div class="vertical-line"></div>
    <div class="detail blue-text">
      <p>Fast Response Time</p>
      <p>Reliable Communication</p>
    </div>
  </div>
</div>

<div class="ho3">
  <div class="content">
    <h2 class="ho3-headline">
      WHAT WE DO <span class="ho3-dash">—</span> We Craft Simple, Scalable Digital Solutions for Complex Challenges.
    </h2>
   
  </div>
  <div class="right23">
    <img src="/img/logo12.png" alt="Image" id="scrollingImage" />
  </div>
</div>
<div class="parallax-container">
  <div class="contentpa">
    <h2>Delivering expert software, web, and blockchain solutions for ambitious projects.</h2>
    <Link to="/contact">
      <button class="buttonpa">Contact Us to Discuss Your Project</button>
    </Link>
  </div>
</div>
<div class="card-container1">
  <div class="card1">
    <i class="fas fa-chart-line"></i>
    <!-- Replace with appropriate class for Mono Icons -->
    <h2>Global Collaboration</h2>
    <p>
      Partnering with clients worldwide to deliver complex digital
      solutions, from web platforms to blockchain projects.
    </p>
  </div>

  <div class="card1">
    <i class="fas fa-shield-alt"></i>
    <!-- Replace with appropriate class for Mono Icons -->
    <h2>Innovation Lab</h2>
    <p>
      Driving technical innovation with creative software and app
      development tailored for ambitious projects.
    </p>
  </div>

  <div class="card1">
    <i class="fas fa-users"></i>
    <!-- Replace with appropriate class for Mono Icons -->
    <h2>Digital Expertise</h2>
    <p>
      Providing reliable, high-performance solutions backed by technical
      know-how and industry best practices.
    </p>
  </div>
</div>

<div class="bb">
  <div class="card-container3">
    <div class="solutions-container">
      <div class="title-container">
        <h1>Solutions</h1>
      </div>
    </div>
  </div>
  <div class="card-container3">
    <div class="card3">
      <i class="fas fa-globe"></i>
      <h3>Blockchain</h3>
      <p>Secure and scalable blockchain solutions for enterprise and innovative digital projects.</p>
      <button class="card-btn3" on:click={() => navigate("/blockchain")}
        ><span>L</span><span>e</span><span>a</span><span>r</span><span>n</span>
        <span>M</span><span>o</span><span>r</span><span>e</span></button
      >
    </div>
    <div class="card3">
      <i class="fas fa-lightbulb"></i>
      <h3>Software Development</h3>
      <p>Custom software built for reliability, performance, and real business impact.</p>
      <button class="card-btn3" on:click={() => navigate("/web")}
        ><span>L</span><span>e</span><span>a</span><span>r</span><span>n</span>
        <span>M</span><span>o</span><span>r</span><span>e</span></button
      >
    </div>
    <div class="card3">
      <i class="fas fa-brain"></i>
      <h3>Web Development</h3>
      <p>Responsive, engaging websites that drive traffic and convert visitors into customers.</p>
      <button class="card-btn3" on:click={() => navigate("/software")}>
        <span>L</span><span>e</span><span>a</span><span>r</span><span>n</span>
        <span>M</span><span>o</span><span>r</span><span>e</span></button
      >
    </div>
  </div>

  <div class="card-container3">
    <div class="card3">
      <i class="fas fa-mobile-alt"></i>
      <h3>Mobile Apps</h3>
      <p>Intuitive, seamless apps that deliver exceptional user experiences across devices.</p>
      <button class="card-btn3" on:click={() => navigate("/mobileapp")}
        ><span>L</span><span>e</span><span>a</span><span>r</span><span>n</span>
        <span>M</span><span>o</span><span>r</span><span>e</span></button
      >
    </div>
    <div class="card3">
      <i class="fas fa-gamepad"></i>
      <h3>Game Development</h3>
      <p>Immersive gaming experiences crafted to engage and retain users.</p>
      <button class="card-btn3" on:click={() => navigate("/game")}>
        <span>L</span><span>e</span><span>a</span><span>r</span><span>n</span>
        <span>M</span><span>o</span><span>r</span><span>e</span>
      </button>
    </div>
    <div class="card3 card3-cta">
      <i class="fas fa-envelope"></i>
      <h3>Contact Us</h3>
      <p>Reach out for a personalized consultation and project guidance.</p>
      <button class="card-btn3" on:click={() => navigate("/contact")}
        ><span>G</span><span>e</span><span>t</span> <span>i</span><span>n</span>
        <span>T</span><span>o</span><span>u</span><span>c</span><span>h</span></button
      >
    </div>
  </div>
</div>
<div class="parallax-container2">
  <div class="contentpa2">
    <h2>
      At Craft2Code, we build software, web, and blockchain solutions that help
      businesses solve complex digital challenges. Our team combines technical
      expertise with strategic thinking to deliver reliable, scalable, and
      innovative solutions tailored to each client. We empower businesses to
      grow, innovate, and succeed in a fast-paced digital world.
    </h2>
    <Link to="/about">
      <button class="buttonpa2">About us</button>
    </Link>
  </div>
</div>
<div class="bli">
  <div class="intro-section">
    <h1 style="font-size: 65px;">
      Our Team
    </h1>
    <p>
      We work with top developers and digital specialists to deliver innovative,
      reliable, and high-impact solutions.
    </p>
  </div>
  <div class="challenges-section">
    <div class="icons">
      <span class="arrow" on:click={() => moveCard("left")}>&#8592;</span>
      <h2>Our Expertise</h2>
      <span class="arrow" on:click={() => moveCard("right")}>&#8594;</span>
    </div>
  </div>
  <div
    class="card-section"
    style:transform="translateX(calc(-{currentIndex * 25}% - 40px))"
  >
    {#each [0, 1, 2, 3] as index}
      {#if index >= currentIndex && index < currentIndex + 3}
        <div class="cardb">
          {#if index === 0}
            <h3>Mobile App Development</h3>
            <p>Seamless and intuitive apps across all platforms.</p>
          {:else if index === 1}
            <h3>Web Development</h3>
            <p>Fully-functional, fast, scalable websites with exceptional UX.</p>
          {:else if index === 2}
            <h3>Data Analytics</h3>
            <p>
              Turning data into actionable insights.
            </p>
          {:else}
            <h3>Cloud Solutions</h3>
            <p>
              Flexible and reliable infrastructure for scaling projects.
            </p>
          {/if}
        </div>
      {/if}
    {/each}
  </div>
</div>

<div
  class="testimonials-section"
  style="padding-top: 50px; padding-bottom: 50px;"
>
  <h3 class="clients-text">Hear from our happy clients.</h3>

  <div class="testimonials-container">
    {#each testimonials as testimonial, index}
      <div
        class="testimonial"
        style:display={index === testimonialIndex ? 'block' : 'none'}
      >
        <p class="quote bigger">{testimonial.quote}</p>
        <p class="author bigger">{testimonial.author}</p>
      </div>
    {/each}
  </div>
  <div class="additional-info1">
    <div class="arrow-buttons-container">
      <button on:click={goToPrevTestimonial} class="arrow-button left11">
        <i class="fas fa-arrow-left"></i>
      </button>
      <button on:click={goToNextTestimonial} class="arrow-button right11">
        <i class="fas fa-arrow-right"></i>
      </button>
    </div>
    <div class="detail1">
      <p>
        REVIEWED ON
        <span style="color: red;">★</span><span style="color: red;">★</span
        ><span style="color: red;">★</span><span style="color: red;">★</span
        ><span style="color: red;">★</span>
        <br />31 reviews
      </p>

      <p></p>
    </div>
    <div class="additional-info2">
      <div class="google-icon">
        <i class="fab fa-google"></i>
      </div>
      <div class="stars">
        <span style="color: yellow;">★</span><span style="color: yellow;"
          >★</span
        ><span style="color: yellow;">★</span><span style="color: yellow;"
          >★</span
        ><span style="color: yellow;">★</span>

        <div class="customer-reviews">CUSTOMER REVIEWS</div>
      </div>
    </div>
  </div>
</div>
<div class="cont">
  <div class="leftco">
    <!-- <div class="top-left-text1">Contact Us</div> -->
    <div class="bottom-left-textc">
      Partner With Us
    </div>
    <div class="left-text">
      We're here to answer your questions and help you determine which
      services best fit your project.
    </div>
    <div class="left-text">Call us at: 76 361 951</div>
    <div class="left-text">Your benefits:</div>
    <div class="benefits-container">
      <div class="benefits">
        <div class="benefit">
          <i class="fas fa-check-circle"></i>
          Client-oriented
        </div>
        <div class="benefit">
          <i class="fas fa-check-circle"></i>
          Independent
        </div>
        <div class="benefit">
          <i class="fas fa-check-circle"></i>
          Competent
        </div>
      </div>
      <div class="benefits">
        <div class="benefit">
          <i class="fas fa-check-circle"></i>
          Results-driven
        </div>
        <div class="benefit">
          <i class="fas fa-check-circle"></i>
          Problem-solving
        </div>
        <div class="benefit">
          <i class="fas fa-check-circle"></i>
          Transparent
        </div>
      </div>
    </div>
    <div class="left-text">What happens next?</div>
    <div class="steps">
      <div class="step">
        <i class="fas fa-arrow-right"></i>
        Schedule a call at your convenience
      </div>
      <div class="step">
        <i class="fas fa-arrow-right"></i>
        Conduct a discovery and consulting meeting
      </div>
      <div class="step">
        <i class="fas fa-arrow-right"></i>
        Prepare a tailored proposal for your project
      </div>
    </div>
  </div>
  <div class="rightco">
    <div class="contact-form-container">
      <h2 style="text-align: center;">Schedule a Free Consultation</h2>
      <div class="contact-form">
        <div class="form-group">
          <div class="name-inputs">
            <input
              type="text"
              id="firstName"
              name="firstName"
              placeholder="First Name"
              bind:value={firstName}
              required
            />
            <input
              type="text"
              id="lastName"
              name="lastName"
              placeholder="Last Name"
              bind:value={lastName}
              required
            />
          </div>
        </div>
        <div class="form-group">
          <input
            type="text"
            id="company"
            name="company"
            placeholder="Company/Organization"
            bind:value={company}
          />
        </div>
        <div class="form-group">
          <input
            type="email"
            id="email"
            name="email"
            placeholder="Company Email"
            bind:value={email}
            required
          />
        </div>
        <div class="form-group">
          <input type="text" id="phone" name="phone" placeholder="Phone" bind:value={phone} />
        </div>
        <div class="form-group">
          <select id="helpOption" name="helpOption" bind:value={helpOption}>
            <option value="">How can we help you?</option>
            <option value="Mobile App Development">Mobile App Development</option>
            <option value="Software Development">Software Development</option>
            <option value="Web Development">Web Development</option>
            <option value="Blockchain">Blockchain</option>
            <option value="Game Development">Game Development</option>
            <option value="Other">Other</option>
          </select>
        </div>
        <div class="form-group">
          <textarea id="message" name="message" rows="6" placeholder="Message" bind:value={message}
          ></textarea>
        </div>
        {#if submitStatus === "success"}
          <p class="form-success">✅ Message sent successfully! We'll be in touch soon.</p>
        {:else if submitStatus === "error"}
          <p class="form-error">❌ Something went wrong. Please try again or email us at craft2code743@gmail.com</p>
        {/if}
        <button type="button" class="submit-button" disabled={submitting} on:click={handleSubmit}>
          {submitting ? "Sending..." : "Submit"}
        </button>
      </div>
    </div>
  </div>
</div>
<div class="logo">
  <div class="leftlo">
    <h2>Recognized by the Best</h2>
    <p style="color: black;">
      Trusted by industry leaders for delivering reliable and innovative digital solutions.
    </p>
  </div>
  <div class="rightlo">
    <img src="/img/2.png" alt="Your Image Description" />
  </div>
</div>
<!-- <footer class="footer" style="background-color: black;"> -->

<footer class="footer">
  <div class="footer-content">
    <div class="leftfoo">
      <div class="footer-section">
        <div class="links-development">
          <div class="quick-links">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/home" style="color: black;">Home</Link></li>
              <li><Link to="/service" style="color: black;">Services</Link></li>
              <li><Link to="/about" style="color: black;">About Us</Link></li>
              <li>
                <Link to="/contact" style="color: black;">Contact Us</Link>
              </li>
            </ul>
          </div>
          <div class="development">
            <h4>Development</h4>
            <ul>
              <li>
                <Link to="/mobileapp" style="color: black;">Mobile App</Link>
              </li>
              <li>
                <Link to="/software" style="color: black;">Web</Link>
              </li>
              <li><Link to="/game" style="color: black;">Game</Link></li>
              <li><Link to="/web" style="color: black;">Software</Link></li>
              <li>
                <Link to="/blockchain" style="color: black;">Blockchain</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

    </div>
    <div class="rightfo">
      <div class="image-containerff">
        <img src="/img/34.png" alt="Footer Image" id="footerImage" />
        <div class="text-overlay">
          <h2 style="transform: scale(0.7);"><img src="/img/logo12.png" /></h2>
        </div>
      </div>
    </div>
  </div>
</footer>
<div class="hofo">
  <div class="detail-containerfo">
    <div class="detailfo">
      <p>
        REVIEWED ON
        <span style="color: red;">★</span><span style="color: red;">★</span
        ><span style="color: red;">★</span><span style="color: red;">★</span
        ><span style="color: red;">★</span>
      </p>
      <p>
        <!-- <span style="color: black; font-size: 24px;">CLUTCH</span> -->
        <span style="color: gray;">31 reviews</span>
      </p>
    </div>
    <div class="vertical-linefo"></div>
    <!-- <div class="detailfo blue-textfo">
      <p>God Of Mining</p>
      <p>Lebanon</p>
    </div> -->
    <div class="vertical-linefo"></div>
    <div class="detailfo blue-textfo">
      <p>T: 76 361 951</p>
      <p>E: Info@craft2code.com</p>
    </div>
    <div class="detailfo blue-textfo">
      <p>
        <a href="https://www.linkedin.com/company/craft2code" target="_blank">
          <i class="fab fa-linkedin"></i>
        </a>
      </p>
      <p>LinkedIn</p>
    </div>

    <div class="detailfo blue-textfo">
      <p>
        <a href="https://www.instagram.com/craft2code/" target="_blank">
          <i class="fab fa-instagram"></i>
        </a>
      </p>
      <p>Instagram</p>
    </div>

    <div class="detailfo blue-textfo">
      <p>
        <a href="https://www.facebook.com/craft2code" target="_blank">
          <i class="fab fa-facebook"></i>
        </a>
      </p>
      <p>Facebook</p>
    </div>

    <div class="detailfo blue-textfo">
      <p>
        <a href="https://maps.app.goo.gl/wCDPsTqkkNU39Fds6" target="_blank">
          <i class="fas fa-map-marker-alt"></i>
        </a>
      </p>
      <p>Location</p>
    </div>
  </div>
  <div class="center-textfooo">
    <p>© 2024Craft2Code Terms & Conditions Privacy Policy</p>
  </div>
</div>

<style>
  body {
    display: flex;
    flex-direction: column; /* Set the direction to column */
  }
  /* --------------------------------------------------------- */
  .parallax-container {
    position: relative;
    width: 100%;
    height: 500px; /* Adjust height as needed */
    margin-bottom: 30px;
    margin-top: 20px;
    background-image: url("/img/3.jpg"); /* Image path */
    background-attachment: fixed;
    background-size: cover;
    background-position: center;
  }

  .contentpa {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
    text-align: center;

    color: white;
  }
  .contentpa h2 {
    font-size: 65px;
    font-family: BreeSerif;
  }

  .buttonpa {
    display: inline-block;
    padding: 14px 24px; /* Adjust padding */
    font-size: 16px; /* Adjust font size */
    background-color: #333333;
    color: #fff;
    border: none;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    font-family: Arial, Helvetica, sans-serif;
    z-index: 1;
    border-radius: 5px; /* Add border-radius */
    transition:
      background-color 0.3s ease,
      color 0.3s ease; /* Add transition */
  }

  .buttonpa::before,
  .buttonpa::after {
    content: "";
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #333333;
    transition: width 0.3s ease; /* Smooth transition animation */
    z-index: -1;
    border-radius: 5px; /* Add border-radius */
  }

  .buttonpa::before {
    left: 50%;
    transform: translateX(-50%);
  }

  .buttonpa::after {
    right: 50%;
    transform: translateX(50%);
  }

  .buttonpa:hover::before {
    width: 0%; /* Shrink the left half of the background color on hover */
  }

  .buttonpa:hover::after {
    width: 0%; /* Shrink the right half of the background color on hover */
  }

  .buttonpa:hover {
    color: #dc1f26;
    background-color: #dddddd; /* Change background color on hover */
  }

  /* --------------------------- */

  .parallax-container2 {
    position: relative;
    width: 100%;
    height: 500px; /* Adjust height as needed */
    margin-bottom: 30px;
    background-image: url("/img/4.jpg"); /* Image path */
    background-attachment: fixed;
    background-size: cover;
    background-position: center;
  }

  .contentpa2 {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
    text-align: center;
    color: white;
  }

  .buttonpa2 {
    display: inline-block;
    padding: 14px 24px; /* Adjust padding */
    font-size: 16px; /* Adjust font size */
    background-color: #333333;
    color: #fff;
    border: none;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    font-family: Arial, Helvetica, sans-serif;
    z-index: 1;
    border-radius: 5px; /* Add border-radius */
    transition:
      background-color 0.3s ease,
      color 0.3s ease; /* Add transition */
  }

  .buttonpa2::before,
  .buttonpa2::after {
    content: "";
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #333333;
    transition: width 0.3s ease; /* Smooth transition animation */
    z-index: -1;
    border-radius: 5px; /* Add border-radius */
  }

  .buttonpa2::before {
    left: 50%;
    transform: translateX(-50%);
  }

  .buttonpa2::after {
    right: 50%;
    transform: translateX(50%);
  }

  .buttonpa2:hover::before {
    width: 0%; /* Shrink the left half of the background color on hover */
  }

  .buttonpa2:hover::after {
    width: 0%; /* Shrink the right half of the background color on hover */
  }

  .buttonpa2:hover {
    color: #dc1f26;
    background-color: #dddddd; /* Change background color on hover */
  }
  /* ----------------------------------------------------- */

  .bli {
    background-size: cover;
    padding: 50px;
    color: #333333;
  }

  .intro-section {
    margin-bottom: 50px;
    font-size: 20px;
    font-family: BreeSerif;
  }

  .challenges-section {
    display: flex;
    justify-content: center; /* Center the content horizontally */
    align-items: center;
    margin-bottom: 50px;
    border-radius: 10px;
  }

  .challenges-section .icons {
    background-color: rgb(19, 18, 18); /* Gray background color */

    display: flex;
    align-items: center;
    border-radius: 10px;
    color: #ffffff;
  }
  .challenges-section .icons .arrow {
    margin: 0 10px; /* Adjust margin between icons and text */
    text-align: center;
  }
  .icons .arrow {
    background-color: black;
    text-align: center;

    border-radius: 100%;
    cursor: pointer;
  }

  .icons .arrow:hover {
    background-color: darkgray;
  }

  .card-section {
    display: flex;
    transition: transform 0.3s ease;
    margin-left: 20%;
    margin-right: 10%;
  }

  .cardb {
    width: 25%; /* Adjusted width */
    height: 300px; /* Increased height */
    background-color: #0c0c0c;
    padding: 20px;
    border-radius: 10px;
    margin-left: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    padding-top: 30px;
    margin-top: 30px;
    margin-bottom: 40px;
  }

  .cardb:last-child {
    margin-right: 0;
  }

  .cardb h3 {
    font-size: 24px;
    margin-bottom: 10px;
    font-family: BreeSerif;
    color: #ffffff;
  }

  .cardb p {
    font-size: 18px;
    font-family: SourceSans;
    color: #ffffff;
  }

  .icons .arrow {
    background-color: black;
    padding: 10px;
    border-radius: 100%;
    cursor: pointer;
    color: white;
    font-size: 24px; /* Adjusted font size */
  }

  .icons .arrow:hover {
    background-color: #dc1f26;
  }
  .hofo {
    padding: 20px;
  }

  .detail-containerfo {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .detailfo {
    flex: 1;
    text-align: center;
    padding: 10px;
    box-sizing: border-box;
  }

  .vertical-linefo {
    border-left: 1px solid #ccc;
    margin: 0 10px;
  }

  .detailfo p {
    margin: 0;
    font-size: 0.8rem;
  }

  .detailfo .blue-textfo i {
    font-size: 20px;
    margin-bottom: 5px;
  }

  .stars {
    font-size: 24px;
  }

  .blue-textfo p:first-child {
    margin: 0;
    font-size: 0.8rem;
    color: #dc1f26;
  }

  .blue-textfo p:first-child i {
    margin: 0;
    font-size: 1.2rem;
    color: #dc1f26;
  }

  .blue-textfo p:last-child {
    color: black;
  }

  .hofo {
    border-top: 1px solid #ccc;
    padding: 10px 0;
    margin-top: 20px;
  }

  .center-textfooo {
    text-align: center;
    margin-top: 20px;
  }
  .rightfo .image-containerff {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .rightfo img {
    width: 100%;
    height: 100%; /* Make the image take full height */
    object-fit: cover; /* Ensure the image covers the container */
    transition: transform 0.5s; /* Add transition effect for scaling */
  }

  .rightfo img:hover {
    transform: scale(1.1); /* Increase scale on hover */
  }
  .text-overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    z-index: 10;
  }


  .footer {
    margin-top: 30px;
    display: flex;
    background-color: #ffffff;
    flex-direction: column;
    justify-content: space-between;
    height: auto; /* Set the footer height to full viewport height */
  }
  .footer-content {
    display: flex;
  }

  .leftfoo {
    height: 100%;
    width: 50%;
  }

  .rightfo {
    width: 50%;
    position: relative;
    display: flex;
    justify-content: center; /* Center content vertically */
    align-items: center; /* Center content horizontally */
    text-align: center;
    height: 100%; /* Ensure it takes full height */
  }

  .leftfoo .footer-section {
    margin-bottom: 20px;
  }

  .rightfo button {
    display: inline-block;
    padding: 14px 24px; /* Adjust padding */
    font-size: 16px; /* Adjust font size */
    background-color: #333333;
    color: #fff;
    border: none;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    font-family: Arial, Helvetica, sans-serif;
    z-index: 1;
    border-radius: 5px; /* Add border-radius */
    transition:
      background-color 0.3s ease,
      color 0.3s ease; /* Add transition */
  }

  .rightfo button::before,
  .rightfo button::after {
    content: "";
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #333333;
    transition: width 0.3s ease; /* Smooth transition animation */
    z-index: -1;
    border-radius: 5px; /* Add border-radius */
  }

  .rightfo button::before {
    left: 50%;
    transform: translateX(-50%);
  }

  .rightfo button::after {
    right: 50%;
    transform: translateX(50%);
  }

  .rightfo button:hover::before {
    width: 0%; /* Shrink the left half of the background color on hover */
  }

  .rightfo button:hover::after {
    width: 0%; /* Shrink the right half of the background color on hover */
  }

  .rightfo button:hover {
    color: #dc1f26;
    background-color: #dddddd; /* Change background color on hover */
  }
  .rightfo h2 {
    color: #333333;
    font-family: BreeSerif;
    border: none;
    border-radius: 5px;
    padding: 10px 20px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  .leftfoo .footer-section h4 {
    color: #333333;
    font-size: 1.8rem;
    font-family: SourceSans;
    font-weight: bold;
    margin-top: 65px;
  }

  .leftfoo .footer-section ul {
    list-style: none;
    padding-top: 0px;
    margin-top: 0;
  }

  .leftfoo .footer-section ul li {
    padding-top: 10px;
    margin-bottom: 10px;
  }

  .leftfoo .footer-section ul li a {
    color: #333333;
    font-family: SourceSans;
    text-decoration: none;
  }

  .leftfoo .footer-section ul li a:hover {
    color: #dc1f26;
  }

  .leftfoo .footer-section input[type="email"] {
    margin-top: 50px;
    padding: 15px;
    border: none;
    border-radius: 5px;
    margin-bottom: 10px;
    margin-left: 20px;
    background-color: #333333;
    color: white;
    border: 2px solid white; /* Set transparent border by default */
    width: calc(100% - 200px); /* Adjusted width to account for margin */
  }

  .leftfoo .footer-section input[type="checkbox"] {
    margin-top: 15px;
    margin-left: 30px;
    margin-right: 10px;
    transform: scale(1);
  }

  .leftfoo .footer-section .checkbox-wrapper {
    display: inline-flex;
    align-items: center;
    margin-top: 15px;
  }
  .leftfoo .footer-section label {
    padding-right: 200px;
    font-size: 0.8rem; /* Increase font size of the checkbox label */
  }
  .leftfoo .footer-section button {
    background-color: #333333;
    margin-left: 30px;
    margin-top: 40px;
    color: white;
    border: none;
    border-radius: 5px;
    padding: 10px 30px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }

  .leftfoo .footer-section button:hover {
    background-color: #dc1f26;
  }
  .rightfo h2 {
    z-index: 10;
  }

  .rightfo button {
    z-index: 10;
    background-color: #333333;
    color: white;
    border: none;
    border-radius: 5px;
    padding: 10px 20px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }

  .links-development {
    display: flex;
  }

  .quick-links,
  .development {
    margin-left: 30px;
    padding-top: 5px;
    flex: 1;
  }

  .quick-links ul,
  .development ul {
    padding: 0;
    margin: 0;
    list-style: none;
  }

  .quick-links h4,
  .development h4 {
    font-size: 1.9rem;
  }

  .bb {
    margin: 0; /* Ensure no margin */
    padding: 20px 0; /* Adjust padding as needed, no horizontal padding */
    left: 0;
    width: 100%; /* Ensure it spans the full width */
    position: relative; /* Ensure it's positioned correctly */
  }
  .logo {
    margin-top: 40px;
    margin-bottom: 50px;
    display: flex;
    background-color: white;
    width: 100%;
    align-items: center;
  }

  .leftlo p {
    font-size: 1.2rem;
    font-family: SourceSans;
  }

  .leftlo h2 {
    font-size: 60px;
    color: #333333;
    font-family: BreeSerif;
  }

  .leftlo {
    flex: 1;
    padding: 20px;
    display: flex;
    flex-direction: column; /* Stack items vertically */
    align-items: center; /* Center items horizontally */
    justify-content: center; /* Center items vertically */
  }

  .rightlo {
    display: flex;
    flex-direction: column; /* Display images in a column */
    width: 50%;
    padding: 20px; /* Adjust padding as needed */
    box-sizing: border-box; /* Include padding in width */
    height: 100%;
  }

  .rightlo img {
    max-height: 400px; /* Set the maximum height */
    width: auto; /* Maintain aspect ratio */
    object-fit: contain; /* Ensure the image is contained within the specified height */
  }
  .cont {
    padding-top: 70px;
    display: flex;
    /* background: linear-gradient(
      to bottom,
      white 0%,
      white 19%,
      #dc1f26 20%,
      red 70%,
      white 71%
    ); */
    /* background: linear-gradient(45deg, #ffffff, #dc1f26, #ffffff); */
    width: 100%;
  }

  .leftco {
    flex: 70%; /* Set the left div to take up 70% of the available space */
    color: #333333;
    padding-left: 120px;
  }

  .left-text {
    padding-top: 50px;
    font-size: 1.3em;
    font-family: BreeSerif;
  }

  .benefits-container {
    display: flex;
    justify-content: space-between;
    padding-top: 20px;
  }

  .benefits {
    flex: 1;
    font-family: BreeSerif;
  }

  .benefit {
    padding: 5px 0;
    font-family: SourceSans;
  }

  .benefit i {
    margin-right: 10px;
  }

  .steps {
    display: flex;
    justify-content: space-between;
    padding-top: 20px;
    font-family: BreeSerif;
  }

  .step {
    padding-bottom: 20px;
    flex: 1;
    font-family: SourceSans;
  }

  .top-left-text1 {
    /* top: 20px; */
    padding-top: 0px;
    margin-top: 0px;
    font-family: SourceSans;

    font-size: 18px;
  }
  .name-inputs {
    display: flex;
  }

  .name-inputs input {
    flex: 1; /* Take up equal space */
    margin-right: 10px; /* Add space between inputs */
  }

  .name-inputs input:last-child {
    margin-right: 0; /* Remove margin from last input */
  }
  .rightco {
    background-color: white;
    /* margin-top: 10px; */
    margin-right: 200px;
    margin-bottom: 30px;
    flex: 50%; /* Set the right div to take up 30% of the available space */
  }

  .contact-form-container {
    display: flex;
    flex-direction: column; /* Align items vertically */
    align-items: center; /* Center items horizontally */
    padding-right: 20px;
  }

  .contact-form-container h2 {
    color: #333333;
    font-family: BreeSerif;
    margin-bottom: 20px;
  }

  .form-group {
    margin-bottom: 20px;
    text-align: left;
    padding-left: 10px;
  }

  .form-group input,
  .form-group select,
  .form-group textarea {
    width: 100%;
    padding: 10px;
    font-size: 16px;
    border: 1px solid #ccc;
    border-radius: 5px;
  }

  .form-group select {
    appearance: none;
    -webkit-appearance: none;
  }

  .form-group textarea {
    resize: vertical;
  }

  .submit-button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  .form-success {
    color: #1a7a3a;
    background-color: #d4edda;
    border: 1px solid #c3e6cb;
    border-radius: 5px;
    padding: 10px 15px;
    margin-bottom: 12px;
    font-size: 0.95rem;
  }

  .form-error {
    color: #842029;
    background-color: #f8d7da;
    border: 1px solid #f5c2c7;
    border-radius: 5px;
    padding: 10px 15px;
    margin-bottom: 12px;
    font-size: 0.95rem;
  }

  .submit-button {
    display: inline-block;
    padding: 14px 24px; /* Adjust padding */
    font-size: 16px; /* Adjust font size */
    background-color: #333333;
    color: #fff;
    border: none;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    font-family: Arial, Helvetica, sans-serif;
    z-index: 1;
    border-radius: 5px; /* Add border-radius */
    transition:
      background-color 0.3s ease,
      color 0.3s ease; /* Add transition */
  }

  .submit-button::before,
  .submit-button::after {
    content: "";
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #333333;
    transition: width 0.3s ease; /* Smooth transition animation */
    z-index: -1;
    border-radius: 5px; /* Add border-radius */
  }

  .submit-button::before {
    left: 50%;
    transform: translateX(-50%);
  }

  .submit-button::after {
    right: 50%;
    transform: translateX(50%);
  }

  .submit-button:hover::before {
    width: 0%; /* Shrink the left half of the background color on hover */
  }

  .submit-button:hover::after {
    width: 0%; /* Shrink the right half of the background color on hover */
  }

  .submit-button:hover {
    color: #dc1f26;
    background-color: #dddddd; /* Change background color on hover */
  }

  .bottom-left-textc {
    font-size: 60px;
    margin-top: 0px;
    font-weight: bold;
    font-family: SourceSans;
  }
  .testimonials-section {
    position: relative;
    text-align: center;

    width: 60%;
    margin-left: auto; /* Auto margin from left */
    margin-right: auto; /* Auto margin from right */
  }

  .testimonial {
    padding: 30px 0; /* Increase padding */
  }

  .quote {
    font-style: italic;
    font-size: 1.7rem; /* Increase font size */
    margin-bottom: 20px;
    width: 100%;
    text-align: left;
    font-weight: bold;
    font-family: BreeSerif;
  }
  .clients-text {
    color: #333333;
    font-family: BreeSerif;
    font-size: 60px; /* Adjust font size */
    margin-bottom: 20px;
  }

  .author {
    font-size: 1.2rem; /* Increase font size */
    font-family: SourceSans;
    color: #333333;
    margin-bottom: 20px;
    margin-top: 30px;
    text-align: left;
  }

  .arrow-buttons-container {
    margin-left: 20px; /* Add margin between buttons and text */
  }

  .additional-info1 {
    display: flex;
    justify-content: space-between; /* Align items to the edges */
    align-items: center; /* Center vertically */
    margin-top: 1px; /* Adjust as needed */
  }

  .detail1 {
    font-size: 1.2rem;
    text-align: right; /* Align text to the right */
  }
  .arrow-button {
    background: none;
    border: none;
    cursor: pointer;
    color: #054f76;
    font-size: 24px;
    margin: 0 10px; /* Add some space between buttons */
  }

  .arrow-button.left11 {
    margin-right: 20px;
  }

  .arrow-button.right11 {
    margin-left: 20px;
  }

  .additional-info2 {
    display: flex;
    align-items: center;
  }

  .google-icon {
    margin-right: 10px;
    font-size: 50px;
    color: #dc1f26;
  }

  .stars1 {
    color: yellow;
    font-size: 24px;
    margin-right: 10px;
  }

  .customer-reviews {
    font-size: 1.2rem;
  }

  .solutions-container {
    text-align: center; /* Center the text and cards */

    font-family: BreeSerif;
  }

  .title-container {
    font-size: 65px;
    margin-bottom: 20px; /* Add margin below the title */
  }

  .card-container3 {
    display: flex;
    justify-content: space-around;

    border-radius: 10px; /* Adjusted border-radius */

    box-sizing: border-box; /* Include padding in width */
  }
  .card3 {
    transition: background-color 2s ease-in-out;
    width: 25%; /* Adjusted width */
    height: 300px; /* Increased height */
    background-color: #ffffff;
    padding: 20px;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    padding-top: 30px;
    margin-top: 30px;
    margin-bottom: 40px;
  }
  .card3 i {
    font-size: 60px;
    text-align: center;
    color: #000000;
    margin-bottom: 10px;
    text-align: center;
  }
  .card3 i:hover {
    color: #dc1f26;
  }
  .card3 h3 {
    margin-bottom: 10px;
    text-align: left;
    font-size: 1.7em;
    color: #333333;
    font-family: BreeSerif;
  }
  .card3:hover h3 {
    color: #dc1f26;
  }
  /* Animation for button */

  .card-btn3 {
    text-align: left;
    background-color: #ffffff;
    color: #dc1f26;
    padding: 8px 1px;
    bottom: 0px;
    border: none;
    border-radius: 5px;
    font-size: 1rem;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .card-btn3::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 2px; /* Adjust the height of the line */
    color: #dc1f26;
    background-color: #dc1f26;
  }

  .card-btn3:hover::before {
    background-color: #dc1f26; /* Change the color of the line on hover */
  }
  .card-btn3 span {
    display: inline-block;
    transition: transform 0.3s ease;
  }
  .card-btn3:hover {
    color: #dc1f26;
  }

  .card3 p {
    font-size: 1.3rem;
    margin-bottom: 20px;
    font-family: SourceSans;
    text-align: left;
  }

  .card3-cta {
    background-color: #333333;
    border: 2px solid #dc1f26;
  }

  .card3-cta i {
    color: #dc1f26;
  }

  .card3-cta h3 {
    color: #ffffff;
  }

  .card3-cta p {
    color: rgba(255, 255, 255, 0.85);
  }

  .card3-cta .card-btn3 {
    background-color: #333333;
    color: #ffffff;
  }

  .card3-cta .card-btn3::before {
    background-color: #dc1f26;
  }

  .card-container1 {
    display: flex;
    justify-content: space-around;
    margin-top: 40px;
    padding-bottom: 80px;
  }

  .card1 {
    /* Removed transition property for demonstration */
    width: 20%; /* Adjusted width */
    height: 300px; /* Increased height */
    background-color: #ffffff;
    padding: 20px;
    border-radius: 10px;

    display: flex;
    flex-direction: column;
    justify-content: space-between; /* Adjusted alignment */

    position: relative;
  }

  .card1 i {
    font-size: 80px;
    color: black;
    text-align: center;
  }
  .card1 i:hover {
    color: #dc1f26;
  }
  .card1 h2 {
    text-align: center;
    color: #333333;
    font-family: BreeSerif;
    font-size: 1.7rem;
    margin-bottom: 0px; /* Add margin bottom */
  }

  .card1 p {
    text-align: center;
    font-family: SourceSans;
    color: #333333;
    font-size: 1.3rem;
    margin-bottom: 10px; /* Add margin bottom */
  }

  .ho3 {
    background: rgb(58, 58, 58); /* Background color gray */
    min-height: 400px; /* Minimum height for better spacing */
    position: relative;
    padding: 40px 20px;
    margin-top: 50px;
    max-width: 100%;
    display: flex;
    border-radius: 5px;
    box-sizing: border-box;
    overflow: hidden;
  }

  .content {
    width: 50%;
    color: rgb(233, 228, 228);
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
  }

  .right23 {
    width: 50%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .right23 img {
    width: 280px;
    height: auto;
    object-fit: contain;
  }

  #scrollingImage {
    position: static;
    max-width: 100%;
    display: block;
    margin: auto;
  }

  .ho3-headline {
    font-size: 42px;
    font-family: BreeSerif;
    font-weight: bold;
    line-height: 1.3;
    margin-bottom: 20px;
    color: #ffffff;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  .ho3-dash {
    color: #dc1f26;
  }

  .supporting-text {
    font-size: 22px;
    font-family: SourceSans;
    color: rgba(255, 255, 255, 0.8);
    margin-bottom: 35px;
    line-height: 1.6;
  }

  .ho3-button {
    display: inline-block;
    padding: 14px 28px;
    font-size: 18px;
    background-color: #dc1f26;
    color: #fff;
    border: none;
    cursor: pointer;
    font-family: Arial, Helvetica, sans-serif;
    border-radius: 5px;
    transition: background-color 0.3s ease, transform 0.2s ease;
    width: fit-content;
  }

  .ho3-button:hover {
    background-color: #b01820;
    transform: translateY(-2px);
  }
  .ho2 {
    padding: 20px;
  }
  .ho2 {
    border-top: 1px solid #ccc; /* Add top border with gray color */
    padding: 10px 0; /* Add padding from top and bottom */
    margin-top: 0px; /* Add some margin from the top */
    margin-left: 30px;
    margin-right: 30px;
  }

  .detail-container {
    display: flex;
    justify-content: space-between;
    margin-top: 15px;
  }

  .detail {
    flex: 1;
    text-align: left;
    padding-left: 15px;
  }

  .vertical-line {
    border-left: 2px solid #ccc;
    margin-top: 5px;
    margin-bottom: 25px;
  }

  .detail p {
    margin: 0;
  }

  .stars {
    /* Your star rating implementation */
    font-size: 24px;
  }

  .blue-text p:first-child {
    color: #333333;
    font-family: BreeSerif;
    font-size: 26px;
    font-weight: bold;
  }

  .blue-text p:last-child {
    color: 333333;
    font-family: SourceSans;
  }
  .ho1 {
    display: flex;
    align-items: center; /* Vertically center content */
    width: 100%;
    height: 100%;

    margin-top: 60px;
    position: relative; /* Add position relative to the parent container */
  }

  .left {
    height: 100%;
    flex: 60%; /* Set left div to take up 60% of the screen width */
    padding-right: 20px; /* Add some space between text and image */
    position: absolute; /* Position the left part absolutely */
    top: 0; /* Position it at the top */
    left: 0; /* Position it at the left */
    z-index: 2; /* Ensure left part is above the image */
    margin-top: 0;
  }

  .left h2 {
    font-size: 65px; /* Set font size */
    font-weight: bold; /* Set font weight to bold */
    font-family: BreeSerif;
    color: #333333;

    padding-top: 5px;
    padding-left: 54px;
  }

  .left p {
    font-size: 32px; /* Set font size */
    color: #333333; /* Set text color to black */
    padding-left: 30px;
    font-family: SourceSans;
  }

  .left button {
    margin-left: 30px;
    margin-top: 20px; /* Add some space between buttons and text */
    font-size: 24px; /* Set font size */
    padding: 10px 20px; /* Add padding */
    background-color: #333333; /* Button background color */
    color: #fff; /* Button text color */
    border: none; /* Remove border */
    cursor: pointer; /* Add cursor pointer */
  }

  .right {
    padding-right: 50px;
    padding-top: 5px;

    position: absolute; /* Position the right part absolutely */
    top: 0; /* Position it at the top */
    right: 0; /* Position it at the right */
    height: 100vh;
    width: 60%; /* Set the width of the right part */
    z-index: 1; /* Ensure right part is behind the left part */
  }

  .image-container {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  .image-container img {
    width: 100%;
    height: 80vh;
    display: block;
    position: absolute;
    top: 0;
    right: 0; /* Position the image to the right */
  }
  /* Pseudo-element to create angled shape */
  .image-background {
    position: absolute;
    top: 0;
    left: calc(0%); /* Adjust as needed based on the desired angle */
    bottom: 60%;
    width: 30%; /* Width of the angled shape */
    background-color: #ffffff; /* Background color of the angled shape */
    transform: skewX(-0deg); /* Skew the shape */
    transform-origin: top left; /* Set transform origin */
    z-index: 1; /* Ensure it stays behind the image */
  }

  .image-background1 {
    position: absolute;
    top: 40%;
    left: calc(0%); /* Adjust as needed based on the desired angle */
    bottom: 0;
    width: 30%; /* Width of the angled shape */
    background-color: #ffffff; /* Background color of the angled shape */
    transform: skewX(-40deg); /* Skew the shape */
    transform-origin: top left; /* Set transform origin */
    z-index: 1; /* Ensure it stays behind the image */
  }

  @keyframes rotateLetters {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes rotateLetters {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  .left .card-btnn {
    background-color: #333333;
    color: white;
    padding: 8px 16px;
    border: none;
    border-radius: 5px;
    font-size: 1rem;
    cursor: pointer;
    transition: background-color 0.3s ease-in-out;
  }
  .left .services-btnn {
    background-color: #e0e0e0;
    color: #333333;
    padding: 8px 16px;
    border: none;
    border-radius: 5px;
    font-size: 1rem;
    cursor: pointer;
    transition: background-color 0.3s ease-in-out;
  }
  .card-btnn {
    background-color: #333333;
    color: white;
    padding: 8px 16px;
    border: none;
    border-radius: 5px;
    font-size: 1rem;
    cursor: pointer;
    transition: background-color 0.3s ease-in-out;
  }
  .card-btnn:hover,
  .services-btnn:hover {
    color: #fff;
    background-color: #dc1f26;
  }

  .services-btnn {
    background-color: #333333;
    color: white;
    padding: 8px 16px;
    border: none;
    border-radius: 5px;
    font-size: 1rem;
    cursor: pointer;
    transition: background-color 0.3s ease-in-out;
  }
  @media (min-width: 1024px) and (max-width: 1324px) {
    .ho1 {
      flex-direction: column; /* Stack elements vertically */
      align-items: center; /* Center align items */
      height: 100%; /* Adjust height */
      margin-bottom: 20%;
    }

    .left,
    .right {
      position: static; /* Reset position to static */
      width: 100%; /* Full width for both columns */
      text-align: center; /* Center text alignment */
    }

    .left {
      padding: 0px; /* Add padding */
    }

    .left h2 {
      font-size: 48px; /* Reduce font size */
      padding-left: 0; /* Reset padding */
    }

    .left p {
      font-size: 24px; /* Reduce font size */
      padding-left: 0; /* Reset padding */
    }

    .left button {
      font-size: 20px; /* Reduce font size */
      margin-left: 0; /* Reset margin */
    }

    .right {
      padding: 0; /* Reset padding */
      margin-top: 20px; /* Add margin */
    }

    .image-container {
      margin-left: 0px;
      margin-right: 0px;

      padding-left: 0px;
      padding-right: 0px;
      height: 60vh; /* Adjust container height */
    }

    .image-container img {
      height: 100%; /* Ensure image covers the container */
    }

    .image-background,
    .image-background1 {
      display: none; /* Hide background shapes */
    }
    .ho3 {
      flex-direction: column;
      height: auto;
      min-height: auto;
      padding: 40px 30px;
      margin-left: 0px;
      margin-right: 0px;
      box-sizing: border-box;
    }

    .content,
    .right23 {
      width: 100%;
      text-align: left;
    }

    .ho3-headline {
      font-size: 30px;
    }

    .supporting-text {
      font-size: 18px;
    }

    .ho3-button {
      font-size: 16px;
      padding: 12px 24px;
    }

    .right23 {
      display: none;
    }

    #scrollingImage {
      position: static;
      transform: none; /* Remove translate */
      margin: 0 auto; /* Center the image */
    }
    .card1 {
      width: 25%; /* Adjust width */
      margin: 15px auto; /* Center cards with margin */
      height: auto; /* Adjust height */
      padding: 20px; /* Adjust padding */
    }

    .card1 i {
      font-size: 75px; /* Adjust font size */
    }

    .card1 h2 {
      font-size: 1.65rem; /* Adjust font size */
    }

    .card1 p {
      font-size: 1.3rem; /* Adjust font size */
    }
    .card3 {
      width: 25%; /* Adjust width */
      margin: 15px auto; /* Center cards with margin */
      height: auto; /* Adjust height */
      padding: 20px; /* Adjust padding */
    }

    .card3 i {
      font-size: 75px; /* Adjust font size */
    }

    .card3 h3 {
      font-size: 1.65rem; /* Adjust font size */
    }

    .card3 p {
      font-size: 1.3rem; /* Adjust font size */
    }

    .card-btn3 {
      font-size: 1.1rem; /* Adjust button font size */
    }
    .parallax-container2 {
      height: auto; /* Adjust height to auto */
    }

    .contentpa2 {
      position: relative; /* Change position to relative */
      top: auto; /* Reset top */
      left: auto; /* Reset left */
      transform: none; /* Reset transform */
      text-align: left; /* Align text to left */
      padding: 20px; /* Add padding */
      margin: 0; /* Reset margin */
      color: white;
      z-index: 2; /* Ensure content is above the background */
    }

    .buttonpa2 {
      margin-top: 20px; /* Add margin to button */
    }
    .cont {
      flex-direction: column;
    }

    .leftco {
      padding-left: 50px;
      padding-right: 50px;
    }

    .rightco {
      margin-right: 50px;
      margin-left: 50px;
      flex: 100%;
    }

    .benefits-container,
    .steps {
      flex-direction: column;
      margin-left: 35%;
    }

    .bottom-left-textc {
      font-size: 3rem;
      text-align: center;
    }

    .left-text {
      font-size: 1.1rem;
      text-align: center;
    }
  }

  @media (min-width: 769px) and (max-width: 1025px) {
    .challenges-section {
      width: 100%;
      text-align: center;
      margin-right: auto;
    }
    .card-section {
      width: 100%;
      margin-left: 0%;
    }
    .title-container,
    .solutions-container {
      padding-top: 0px;
      margin-top: 0px;
    }

    .logo {
      margin-left: 0px;
      margin-right: 0px;

      padding-left: 0px;
      padding-right: 0px;
      flex-direction: column; /* Stack items vertically */
      text-align: center; /* Center align text */
    }

    .leftlo,
    .rightlo {
      width: 100%; /* Take full width on smaller screens */
      padding: 0px; /* Adjust padding */
    }

    .rightlo {
      margin-top: 20px; /* Add margin to separate from the text */
    }

    .leftlo h2 {
      font-size: 40px; /* Reduce font size for smaller screens */
    }

    .leftlo p {
      font-size: 1rem; /* Reduce font size for smaller screens */
    }

    .rightlo img {
      max-width: 100%; /* Set maximum width to fill container */
      max-height: none; /* Remove maximum height */
    }
    .cont {
      flex-direction: column;
    }

    .leftco {
      padding-left: 50px;
      padding-right: 50px;
    }

    .rightco {
      margin-right: 50px;
      margin-left: 50px;
      flex: 100%;
    }

    .benefits-container,
    .steps {
      flex-direction: column;
      margin-left: 30%;
    }

    .bottom-left-textc {
      font-size: 3rem;
      text-align: center;
    }

    .left-text {
      font-size: 1.1rem;
      text-align: center;
    }
    .footer {
      display: block; /* Stack footer sections */
      padding: 10px; /* Adjust padding */
    }

    .footer-content {
      flex-direction: column; /* Stack footer sections vertically */
    }

    .leftfoo,
    .rightfo {
      width: 100%; /* Take full width */
    }

    .leftfoo .footer-section h4 {
      font-size: 1.3rem; /* Adjust font size */
      margin-top: 20px; /* Adjust margin */
    }

    .leftfoo .footer-section input[type="email"] {
      margin-top: 20px;
      padding: 10px; /* Adjust padding */
      width: calc(100% - 20px); /* Adjust width */
    }

    .leftfoo .footer-section label {
      padding-right: 20px; /* Adjust padding */
      font-size: 0.75rem; /* Adjust font size */
    }

    .leftfoo .footer-section button {
      margin-left: 30;
      margin-top: 20px; /* Adjust margins */
      padding: 10px 20px; /* Adjust padding */
      font-size: 15px; /* Adjust font size */
    }
    .hofo {
      padding: 10px; /* Adjust padding */
      flex-direction: row;
    }

    .detail-containerfo {
      display: flex;
      flex-wrap: wrap;
    }

    .detailfo {
      width: 50%; /* Two items per row */
      box-sizing: border-box;
    }

    .vertical-linefo {
      display: none; /* Hide vertical lines */
    }

    .detailfo:nth-child(1),
    .detailfo:nth-child(2),
    .detailfo:nth-child(3) {
      width: 100%; /* Make the first three items take the full width */
    }
    .center-textfooo {
      font-size: 0.9rem; /* Adjust font size */
    }
    .ho1 {
      flex-direction: column; /* Stack elements vertically */
      align-items: center; /* Center align items */
      height: auto; /* Adjust height */
      margin-bottom: 0px;
      margin-left: 0px;
      margin-right: 0px;

      padding-left: 0px;
      padding-right: 0px;
      width: 100%;
      margin-bottom: 1%;
      padding-bottom: 0px;
    }
    .left,
    .right {
      position: static; /* Reset position to static */
      width: 100%; /* Full width for both columns */
      text-align: center; /* Center text alignment */
      margin-left: 0px;
      margin-right: 0px;

      padding-left: 0px;
      padding-right: 0px;
    }

    .left {
      padding: 0px; /* Add padding */
      padding-bottom: 0px;
      height: auto;
      margin-bottom: 0px;
    }

    .left h2 {
      font-size: 40px; /* Further reduce font size */
      padding-left: 0; /* Reset padding */
    }

    .left p {
      font-size: 20px; /* Further reduce font size */
      padding-left: 0; /* Reset padding */
    }

    .left button {
      font-size: 18px; /* Further reduce font size */
      margin-left: 0; /* Reset margin */
    }

    .right {
      padding: 0; /* Reset padding */
      margin-top: 0px; /* Add margin */
      padding-top: 0px;
      margin-bottom: 0px;
      padding-bottom: 0px;
      height: auto;
    }

    .image-container {
      margin-left: 0px;
      margin-right: 0px;
      margin-top: 0px;
      padding-top: 0px;

      padding-left: 0px;
      padding-right: 0px;
      height: 40vh; /* Adjust container height */
    }

    .image-container img {
      height: 100%; /* Ensure image covers the container */
    }

    .image-background,
    .image-background1 {
      display: none; /* Hide background shapes */
    }
    .ho2 {
      margin-left: 0px;
      margin-right: 0px;

      padding-left: 0px;
      padding-right: 0px;
    }

    .detail-container {
      flex-direction: column;
      align-items: center;
    }

    .detail {
      text-align: center;
      padding-left: 0;
      margin-bottom: 15px;
    }

    .vertical-line {
      display: none;
    }

    .blue-text p:first-child {
      font-size: 22px;
    }

    .blue-text p:last-child {
      font-size: 18px;
    }

    .detail-container {
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
    }

    .detail {
      text-align: left;
      padding-left: 10px;
    }

    .vertical-line {
      display: block;
    }

    .blue-text p:first-child {
      font-size: 24px;
    }

    .blue-text p:last-child {
      font-size: 20px;
    }
    .ho3 {
      flex-direction: column;
      height: auto;
      min-height: auto;
      padding: 35px 25px;
      margin-left: 0px;
      margin-right: 0px;
      width: 100%;
      box-sizing: border-box;
    }

    .content,
    .right23 {
      width: 100%;
      text-align: left;
    }

    .ho3-headline {
      font-size: 26px;
    }

    .supporting-text {
      font-size: 16px;
    }

    .ho3-button {
      font-size: 15px;
      padding: 12px 22px;
    }

    .right23 {
      display: none;
    }
    .parallax-container {
      height: 400px; /* Adjust height for tablet */
    }

    .contentpa h2 {
      font-size: 45px; /* Adjust font size */
    }

    .buttonpa {
      padding: 12px 22px; /* Adjust padding */
      font-size: 15px; /* Adjust font size */
    }
    .card-container1 {
      padding-bottom: 0px;
      margin-bottom: 0px;
    }
    .card1 {
      width: 30%; /* Adjust width */
      margin: 0px auto; /* Center cards with margin */
      height: auto; /* Adjust height */
      padding: 20px; /* Adjust padding */
    }

    .card1 i {
      font-size: 70px; /* Adjust font size */
    }

    .card1 h2 {
      font-size: 1.6rem; /* Adjust font size */
    }

    .card1 p {
      font-size: 1.25rem; /* Adjust font size */
    }
    .card3 {
      width: 30%; /* Adjust width */
      margin: 15px auto; /* Center cards with margin */
      height: auto; /* Adjust height */
      padding: 20px; /* Adjust padding */
    }

    .card3 i {
      font-size: 70px; /* Adjust font size */
    }

    .card3 h3 {
      font-size: 1.6rem; /* Adjust font size */
    }

    .card3 p {
      font-size: 1.25rem; /* Adjust font size */
    }

    .card-btn3 {
      font-size: 1.1rem; /* Adjust button font size */
    }
    .parallax-container2 {
      height: auto; /* Adjust height to auto */
    }

    .contentpa2 {
      position: relative; /* Change position to relative */
      top: auto; /* Reset top */
      left: auto; /* Reset left */
      transform: none; /* Reset transform */
      text-align: left; /* Align text to left */
      padding: 20px; /* Add padding */
      margin: 0; /* Reset margin */
      color: white;
      z-index: 2; /* Ensure content is above the background */
    }

    .buttonpa2 {
      margin-top: 20px; /* Add margin to button */
    }
    .testimonials-section {
      width: 80%;
      margin: 0 auto;
      padding-top: 30px;
      padding-bottom: 30px;
    }

    .clients-text {
      font-size: 40px;
      margin-bottom: 10px;
    }

    .testimonial {
      padding: 20px 0;
    }

    .quote {
      font-size: 1.5rem;
      margin-bottom: 10px;
    }

    .author {
      font-size: 1rem;
      margin-top: 20px;
    }

    .arrow-buttons-container {
      margin-left: 10px;
    }

    .arrow-button {
      font-size: 20px;
    }

    .google-icon {
      font-size: 40px;
      margin-bottom: 10px; /* Add margin bottom for spacing */
    }

    .detail1 {
      font-size: 1.2rem;
      text-align: left;
      margin-top: 10px;
    }

    .additional-info1 {
      flex-direction: column; /* Change flex direction to column */
      align-items: left; /* Align items to the end */
    }
    .bb {
      margin-top: 0px;
      padding-top: 0px;
    }
  }
  @media (min-width: 480px) and (max-width: 769px) {
    .footer {
      display: block; /* Stack footer sections */
      padding: 10px; /* Adjust padding */
    }

    .footer-content {
      flex-direction: column; /* Stack footer sections vertically */
    }

    .leftfoo,
    .rightfo {
      width: 100%; /* Take full width */
    }

    .text-overlay h2 {
      transform: scale(0.5);
    }

    .leftfoo .footer-section h4 {
      font-size: 1.2rem; /* Adjust font size */
      margin-top: 20px; /* Adjust margin */
    }

    .leftfoo .footer-section input[type="email"] {
      margin-top: 20px;
      padding: 10px; /* Adjust padding */
      width: calc(100% - 20px); /* Adjust width */
    }

    .leftfoo .footer-section label {
      padding-right: 20px; /* Adjust padding */
      font-size: 0.7rem; /* Adjust font size */
    }

    .leftfoo .footer-section button {
      margin-left: 30;
      margin-top: 20px; /* Adjust margins */
      padding: 10px 20px; /* Adjust padding */
      font-size: 14px; /* Adjust font size */
    }
    .hofo {
      padding: 10px; /* Adjust padding */
      flex-direction: row;
    }

    .detail-containerfo {
      display: flex;
      flex-wrap: wrap;
    }

    .detailfo {
      width: 50%; /* Two items per row */
      box-sizing: border-box;
    }

    .vertical-linefo {
      display: none; /* Hide vertical lines */
    }

    .detailfo:nth-child(1),
    .detailfo:nth-child(2),
    .detailfo:nth-child(3) {
      width: 100%; /* Make the first three items take the full width */
    }

    .center-textfooo {
      font-size: 0.8rem; /* Adjust font size */
    }
    .rightfo button {
      padding: 8px 8px; /* Adjust padding for smaller screens */
      font-size: 14px; /* Reduce font size for smaller screens */
    }
    .rightfo h2 img {
      transform: scale(1); /* Adjust the scale of the image */
    }

    .text-overlay h2 {
      margin-top: 0; /* Adjust margin to remove distance */
      margin-bottom: 0; /* Adjust margin to remove distance */
      padding-bottom: 0px;
    }

    .cont {
      flex-direction: column;
    }

    .leftco {
      padding-left: 20px;
      padding-right: 20px;
    }

    .rightco {
      margin-right: 20px;
      margin-left: 20px;
      flex: 100%;
    }

    .benefits-container,
    .steps {
      flex-direction: column;
      padding-left: 30%;
    }

    .bottom-left-textc {
      font-size: 2rem;
      text-align: center;
    }

    .left-text {
      font-size: 1rem;
      text-align: center;
    }
    .parallax-container {
      height: auto; /* Allow height to fit content */
      min-height: 350px;
      background-attachment: scroll; /* Disable parallax effect on mobile */
    }

    .contentpa {
      width: 90%;
      padding: 20px 10px;
      box-sizing: border-box;
    }

    .contentpa h2 {
      font-size: 26px; /* Smaller font size */
      word-wrap: break-word;
      overflow-wrap: break-word;
    }

    .buttonpa {
      padding: 10px 20px; /* Adjust padding */
      font-size: 14px; /* Adjust font size */
    }

    .left,
    .right {
      position: static; /* Reset position to static */
      width: 100%; /* Full width for both columns */
      text-align: center; /* Center text alignment */
      padding-left: 0px;
      padding-right: 0px;
      margin-left: 0px;
      margin-right: 0px;
    }

    .left {
      padding: 0px; /* Add padding */
    }

    .left h2 {
      font-size: 36px; /* Further reduce font size */
      padding-left: 0; /* Reset padding */
    }

    .left p {
      font-size: 18px; /* Further reduce font size */
      padding-left: 0; /* Reset padding */
    }

    .left button {
      font-size: 16px; /* Further reduce font size */
      margin-left: 0; /* Reset margin */
    }

    .right {
      padding: 0; /* Reset padding */
      margin-top: 20px; /* Add margin */
      margin-bottom: 0px;
      padding-bottom: 0px;
      height: auto;
    }

    .image-container {
      height: 40vh; /* Adjust container height */
    }

    .image-container img {
      height: 100%; /* Ensure image covers the container */
    }

    .image-background,
    .image-background1 {
      display: none; /* Hide background shapes */
    }
    .ho2 {
      margin-left: 10px;
      margin-right: 10px;
    }

    .center-textfooo {
      font-size: 0.8rem; /* Adjust font size */
    }
    .ho3 {
      flex-direction: column;
      height: auto;
      min-height: auto;
      padding: 30px 20px;
      margin-left: 0px;
      margin-right: 0px;
      width: 100%;
      box-sizing: border-box;
    }

    .content {
      width: 100%;
      text-align: left;
      padding: 10px;
    }
    .bli {
      display: none;
    }

    .ho3-headline {
      font-size: 22px;
      line-height: 1.4;
    }

    .supporting-text {
      font-size: 15px;
      margin-bottom: 20px;
    }

    .ho3-button {
      font-size: 14px;
      padding: 10px 20px;
    }

    .right23 {
      display: none;
    }

    #scrollingImage {
      position: static;
      transform: none; /* Remove translate */
      margin: 0 auto; /* Center the image */
    }
    .card-container1 {
      margin-bottom: 0px;
      padding-bottom: 0px;
      margin-left: 0px;
      margin-right: 0px;
      width: 100%;
      flex-direction: column; /* Stack cards vertically */
      align-items: center; /* Center align the cards */
    }
    .card1 {
      width: 100%; /* Adjust width */
      margin: 10px 0; /* Center cards with margin */
      height: auto; /* Adjust height */
      padding: 0px; /* Adjust padding */
    }

    .card1 i {
      font-size: 60px; /* Adjust font size */
    }

    .card1 h2 {
      font-size: 1.5rem; /* Adjust font size */
    }

    .card1 p {
      font-size: 1.2rem; /* Adjust font size */
    }
    .card-container3 {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      margin-left: 0px;
      margin-right: 0px;
      padding-left: 0px;
      padding-right: 0px;
    }

    .card3 {
      width: 45%; /* Adjust width */
      margin: 10px 0; /* Center cards with margin */
      height: auto; /* Adjust height */
      padding: 18px; /* Adjust padding */
    }

    .card3 i {
      font-size: 60px; /* Adjust font size */
    }

    .card3 h3 {
      font-size: 1.5rem; /* Adjust font size */
    }

    .card3 p {
      font-size: 1.2rem; /* Adjust font size */
    }

    .card-btn3 {
      font-size: 1rem; /* Adjust button font size */
    }

    .title-container {
      font-size: 3rem; /* Adjust font size */
      margin-bottom: 18px; /* Adjust margin */
      margin-left: 0px;
      margin-right: 0px;
      padding-left: 0px;
      padding-right: 0px;
    }
    .parallax-container2 {
      margin-left: 0px;
      margin-right: 0px;
      padding-left: 0px;
      padding-right: 0px;
      height: auto; /* Adjust height to auto */
    }

    .contentpa2 {
      position: relative; /* Change position to relative */
      top: auto; /* Reset top */
      left: auto; /* Reset left */
      transform: none; /* Reset transform */
      text-align: left; /* Align text to left */
      padding: 20px; /* Add padding */
      margin: 0; /* Reset margin */
      color: white;
      z-index: 2; /* Ensure content is above the background */
    }

    .buttonpa2 {
      margin-top: 20px; /* Add margin to button */
    }
    .testimonials-section {
      width: 90%;
      padding-top: 0px;

      margin-top: 0px;
      padding-bottom: 20px;
    }

    .clients-text {
      font-size: 40px;
      margin-bottom: 10px;
    }

    .testimonial {
      padding: 20px 0;
    }

    .quote {
      font-size: 1.5rem;
      margin-bottom: 10px;
    }

    .author {
      font-size: 1rem;
      margin-top: 20px;
    }

    .arrow-buttons-container {
      margin-left: 10px;
    }

    .arrow-button {
      font-size: 20px;
    }

    .google-icon {
      font-size: 40px;
      margin-bottom: 10px; /* Add margin bottom for spacing */
    }

    .detail1 {
      font-size: 1.2rem;
      text-align: left;
      margin-top: 10px;
    }

    .additional-info1 {
      flex-direction: column; /* Change flex direction to column */
      align-items: left; /* Align items to the end */
    }
    .logo {
      margin-left: 0px;
      margin-right: 0px;
      padding-left: 0px;
      padding-right: 0px;
      width: 100%;
      flex-direction: column; /* Stack items vertically */
      text-align: center;
    }

    .leftlo,
    .rightlo {
      width: 100%; /* Take full width on smaller screens */
      padding: 10px; /* Adjust padding */
      margin-left: 0px;
      margin-right: 0px;
      padding-left: 0px;
      padding-right: 0px;
    }

    .rightlo {
      margin-top: 20px; /* Add margin to separate from the text */
    }

    .leftlo h2 {
      font-size: 40px; /* Reduce font size for smaller screens */
    }

    .leftlo p {
      font-size: 1rem; /* Reduce font size for smaller screens */
    }

    .rightlo img {
      max-width: 90%; /* Set maximum width to fill container */
      max-height: none; /* Remove maximum height */
    }
    .ho1 {
      flex-direction: column;
      /* align-items: center; */
      width: 100%;
      height: auto;
      margin-bottom: 0%;
      padding-left: 0px;
      padding-right: 0px;
      margin-left: 0px;
      margin-right: 0px;
      padding-bottom: 0px;
    }
  }

  @media (max-width: 480px) {
    .logo {
      margin-left: 0px;
      margin-right: 0px;
      padding-left: 0px;
      padding-right: 0px;
      width: 100%;
      flex-direction: column; /* Stack items vertically */
      text-align: center;
    }

    .leftlo,
    .rightlo {
      width: 100%; /* Take full width on smaller screens */
      margin-left: 0px;
      margin-right: 0px;
      padding-left: 0px;
      padding-right: 0px;
    }

    .rightlo {
      margin-top: 20px; /* Add margin to separate from the text */
    }

    .leftlo h2 {
      font-size: 40px; /* Reduce font size for smaller screens */
    }

    .leftlo p {
      font-size: 1rem; /* Reduce font size for smaller screens */
    }

    .rightlo img {
      max-width: 90%; /* Set maximum width to fill container */
      max-height: none; /* Remove maximum height */
    }
    .parallax-container2 {
      height: auto; /* Adjust height to auto */
    }

    .contentpa2 {
      position: relative; /* Change position to relative */
      top: auto; /* Reset top */
      left: auto; /* Reset left */
      transform: none; /* Reset transform */
      text-align: left; /* Align text to left */
      padding: 20px; /* Add padding */
      margin: 0; /* Reset margin */
      color: white;
      z-index: 2; /* Ensure content is above the background */
    }

    .buttonpa2 {
      margin-top: 20px; /* Add margin to button */
    }
    .ho1 {
      flex-direction: column;
      /* align-items: center; */
      width: 100%;
      height: 100%;
      margin-bottom: 5%;
      padding-left: 0px;
      padding-right: 0px;
      margin-left: 0px;
      margin-right: 0px;
    }
    /* .ho1 {
      display: none;
    } */
    .left,
    .right {
      position: static; /* Reset position to static */
      width: 100%; /* Full width for both columns */
      text-align: center; /* Center text alignment */
      padding-left: 0px;
      padding-right: 0px;
      margin-left: 0px;
      margin-right: 0px;
    }

    .left h2 {
      font-size: 36px; /* Further reduce font size */
      padding-left: 0; /* Reset padding */
    }

    .left p {
      font-size: 18px; /* Further reduce font size */
      padding-left: 0; /* Reset padding */
    }

    .left button {
      font-size: 16px; /* Further reduce font size */
      margin-left: 0; /* Reset margin */
    }

    .right {
      padding: 0; /* Reset padding */
      margin-top: 20px; /* Add margin */
    }

    .image-container {
      height: 40vh; /* Adjust container height */
    }

    .image-container img {
      height: 100%; /* Ensure image covers the container */
    }

    .image-background,
    .image-background1 {
      display: none; /* Hide background shapes */
    }
    .footer {
      display: block; /* Stack footer sections */
      padding: 10px; /* Adjust padding */
    }

    .footer-content {
      flex-direction: column; /* Stack footer sections vertically */
    }

    .leftfoo,
    .rightfo {
      width: 100%; /* Take full width */
    }
        .text-overlay h2 {
      transform: scale(0.5);
        }
    .leftfoo .footer-section h4 {
      font-size: 1.2rem; /* Adjust font size */
      margin-top: 20px; /* Adjust margin */
    }

    .leftfoo .footer-section input[type="email"] {
      margin-top: 20px;
      padding: 10px; /* Adjust padding */
      width: calc(100% - 20px); /* Adjust width */
      margin-left: 30px;
    }

    .leftfoo .footer-section label {
      padding-right: 20px; /* Adjust padding */
      margin-left: 0px;
      font-size: 0.7rem; /* Adjust font size */
    }
    .leftfoo .footer-section input[type="checkbox"] {
      margin-left: 30px;
    }
    .leftfoo .footer-section button {
      margin-left: 30px;
      margin-top: 20px; /* Adjust margins */
      padding: 10px 20px; /* Adjust padding */
      font-size: 14px; /* Adjust font size */
    }

    .hofo {
      padding: 10px; /* Adjust padding */
    }

    .detail-containerfo {
      flex-wrap: wrap;
    }

    .detailfo {
      width: 50%;
      box-sizing: border-box;
    }

    .detailfo:nth-child(3) {
      width: 100%; /* Full width for the address section */
      padding: 10px 0; /* Add some padding for the address section */
    }

    .vertical-linefo {
      display: none;
    }
    .center-textfooo {
      font-size: 0.8rem; /* Adjust font size */
    }
    .rightfo button {
      padding: 8px 8px; /* Adjust padding for smaller screens */
      font-size: 14px; /* Reduce font size for smaller screens */
    }
    .rightfo h2 img {
      transform: scale(1); /* Adjust the scale of the image */
    }

    .text-overlay h2 {
      margin-top: 0; /* Adjust margin to remove distance */
      margin-bottom: 0; /* Adjust margin to remove distance */
      padding-bottom: 0px;
    }

    .cont {
      flex-direction: column;
      margin-top: 0px;
      padding-top: 10px;
    }

    .leftco {
      padding-left: 20px;
      padding-right: 20px;
      margin-top: 0px;
      padding-top: 0px;
    }

    .rightco {
      margin-right: 20px;
      margin-left: 20px;
      flex: 100%;
    }

    .benefits-container,
    .steps {
      flex-direction: column;
      width: 50%;
      margin-left: auto;
      margin-right: auto;
    }

    .bottom-left-textc {
      font-size: 2rem;
      text-align: center;
      margin-top: 0px;
      padding-top: 0px;
    }

    .left-text {
      font-size: 1rem;
      text-align: center;
    }
    .bli {
      display: none;
    }
    .testimonials-section {
      width: 90%;
      padding-top: 0px;

      margin-top: 0px;
      padding-bottom: 20px;
    }

    .clients-text {
      font-size: 30px;
      margin-bottom: 5px;
    }

    .testimonial {
      padding: 15px 0;
    }

    .quote {
      font-size: 1.2rem;
      margin-bottom: 5px;
    }

    .author {
      font-size: 0.8rem;
      margin-top: 15px;
    }

    .arrow-buttons-container {
      margin-left: 5px;
    }

    .arrow-button {
      font-size: 18px;
    }

    .google-icon {
      margin-right: 10px;
      font-size: 30px;
      color: #dc1f26;
    }

    .customer-reviews {
      font-size: 0.8rem;
    }

    .detail1 {
      font-size: 1.2rem;
      text-align: left;
      margin-top: 10px; /* Add margin at the top */
    }

    .additional-info1 {
      flex-direction: column; /* Change flex direction to column */
      align-items: left; /* Align items to the end */
    }

    .cardb {
      width: 90%;
      margin-bottom: 20px;
    }
    .parallax-container2 {
      margin-left: 0px;
      margin-right: 0px;
      position: relative;
      height: auto;
      background-image: none; /* Remove the parallax background image */
      background-color: #333333; /* Set a background color */
    }

    .contentpa2 {
      padding: 0px;
      margin-top: 20px;
      text-align: left;
      color: white;
      position: relative; /* Ensure content is positioned correctly */
      z-index: 1; /* Ensure content appears above the background */
    }

    .buttonpa2 {
      margin-top: 20px;
      background-color: #dc1f26;
    }
    .buttonpa2::before,
    .buttonpa2::after {
      background-color: #dc1f26;
    }
    .contentpa2 {
      padding: 20px;
      margin-top: 20px; /* Adjust margin as needed */
      text-align: left;
      color: white;
    }

    .buttonpa2 {
      margin-top: 20px; /* Adjust margin as needed */
    }

    .title-container {
      font-size: 2rem; /* Adjust font size */
      margin-bottom: 15px; /* Adjust margin */
      margin-left: 0px;
      margin-right: 0px;
    }
    .card-container3 {
      flex-direction: column; /* Stack cards vertically */
      align-items: center; /* Center align the cards */
      margin-left: 0px;
      margin-right: 0px;
      padding-left: 0px;
      padding-right: 0px;
    }

    .card3 {
      width: 90%; /* Full width with margin */
      margin: 0px 0px; /* Center cards with margin */
      height: auto; /* Adjust height */
      padding-top: 15px; /* Adjust padding */
    }

    .card3 i {
      font-size: 50px; /* Smaller font size */
    }

    .card3 h3 {
      font-size: 1.4rem; /* Adjust font size */
    }

    .card3 p {
      font-size: 1.1rem; /* Adjust font size */
    }

    .card-btn3 {
      font-size: 0.9rem; /* Adjust button font size */
    }
    .card-container1 {
      margin-bottom: 0px;
      padding-bottom: 0px;
      margin-left: 0px;
      margin-right: 0px;
      width: 100%;
      flex-direction: column; /* Stack cards vertically */
      align-items: center; /* Center align the cards */
    }

    .card1 {
      width: 90%; /* Full width with margin */
      margin: 0px 0px; /* Center cards with margin */
      height: auto; /* Adjust height */
      padding: 15px; /* Adjust padding */
    }

    .card1 i {
      font-size: 50px; /* Smaller font size */
    }

    .card1 h2 {
      font-size: 1.4rem; /* Adjust font size */
    }

    .card1 p {
      font-size: 1.1rem; /* Adjust font size */
    }
    .parallax-container {
      margin-left: 0px;
      margin-right: 0px;
      padding-left: 0px;
      padding-right: 0px;
      height: auto; /* Allow height to fit content */
      min-height: 300px;
      background-attachment: scroll; /* Disable parallax effect on mobile */
    }

    .contentpa {
      width: 90%;
      padding: 20px 10px;
      box-sizing: border-box;
    }

    .contentpa h2 {
      font-size: 22px; /* Smaller font size */
      word-wrap: break-word;
      overflow-wrap: break-word;
    }

    .buttonpa {
      padding: 10px 20px; /* Adjust padding */
      font-size: 13px; /* Adjust font size */
    }
    .ho1 {
      flex-direction: column; /* Stack elements vertically */
      align-items: center; /* Center align items */
      height: auto; /* Adjust height */
      margin-bottom: 0px;
      margin-left: 0px;
      margin-right: 0px;
      width: 100%;
      padding-left: 0px;
      padding-right: 0px;
      margin-bottom: 1%;
      padding-bottom: 0px;
    }
    .left {
      padding-bottom: 0px;
      margin-bottom: 0px;
    }
    .left h2 {
      font-size: 32px; /* Further reduce font size */
      margin-left: 0;
      margin-right: 0px;
    }

    .left p {
      font-size: 16px; /* Further reduce font size */
      margin-left: 0;
      margin-right: 0px;
    }

    .left button {
      font-size: 14px; /* Further reduce font size */
      margin-left: 0;
      margin-right: 0px;
    }

    .image-container {
      height: 100%; /* Adjust container height */
      margin-left: 0;
      margin-right: 0px;
      padding-left: 0px;
      padding-right: 0px;
      margin-bottom: 0px;
      padding-bottom: 0px;
      padding-top: 0px;
      margin-top: 0px;
    }
    .right {
      height: 40vh;
      margin-bottom: 0px;
      padding-bottom: 0px;
      margin-top: 0px;
      padding-top: 0px;
    }
    .ho2 {
      margin-left: 0px;
      margin-right: 0px;
      margin-top: 3%;
      padding-top: 0px;
      margin-bottom: 0px;
      padding-bottom: 0px;
    }

    .detail-container {
      flex-direction: column;
      align-items: center;
      margin-top: 0px;
      padding-top: 0px;
      /* margin-left: 0px;
      margin-right: 0px; */
    }

    .detail {
      text-align: center;
      margin-top: 10px;
      padding-left: 0;
      margin-bottom: 8px;
    }

    .vertical-line {
      display: none;
    }

    .blue-text p:first-child {
      font-size: 18px;
    }

    .blue-text p:last-child {
      font-size: 14px;
    }
    .ho3 {
      flex-direction: column;
      height: auto;
      min-height: auto;
      padding: 25px 15px;
      margin-left: 0px;
      width: 100%;
      margin-right: 0px;
      box-sizing: border-box;
    }

    .content {
      width: 100%;
      padding: 10px;
      text-align: left;
    }
    .right23 {
      display: none;
    }

    .ho3-headline {
      font-size: 18px;
      line-height: 1.4;
    }

    .supporting-text {
      font-size: 13px;
      margin-bottom: 15px;
    }

    .ho3-button {
      font-size: 13px;
      padding: 10px 18px;
    }
  }

</style>
